import { HomeContainer } from './style'
import HomeHero from './HomeHero'
import HomeCards from './HomeCards'
import HomeRoadBlocks from './HomeRoadBlocks'
import { DataContext } from 'contexts/DataContextContainer'
import { useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'

function Home() {
  const { lang } = useContext(DataContext)
  const { t } = useTranslation()
  useEffect(() => {
    document.title = t('pg_title_home')
  }, [lang, t])

  return (
    <HomeContainer>
      <HomeHero />
      <HomeCards />
      <HomeRoadBlocks />
    </HomeContainer>
  )
}

export default Home
